import { render, staticRenderFns } from "./layoutAccountsMenu.vue?vue&type=template&id=f387aca6"
import script from "./layoutAccountsMenu.vue?vue&type=script&lang=js"
export * from "./layoutAccountsMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports